import { render } from "./Wall.vue?vue&type=template&id=0caf5c0b&scoped=true&ts=true"
import script from "./Wall.vue?vue&type=script&lang=ts"
export * from "./Wall.vue?vue&type=script&lang=ts"

import "./Wall.vue?vue&type=style&index=0&id=0caf5c0b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caf5c0b"]])

export default __exports__